import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const auth = () => ({ Authorization: `Bearer ${localStorage.getItem('session_token')}` });

export const aiApi = {
  models: () => axios.get(`${API}/ai/models`, { headers: auth() }).then((r) => r.data),
  selectModel: (model) => axios.put(`${API}/ai/models/selected`, { model }, { headers: auth() }).then((r) => r.data),
  chats: () => axios.get(`${API}/ai/chats`, { headers: auth() }).then((r) => r.data.chats),
  createChat: (payload = {}) => axios.post(`${API}/ai/chats`, payload, { headers: auth() }).then((r) => r.data),
  chat: (id) => axios.get(`${API}/ai/chats/${id}`, { headers: auth() }).then((r) => r.data),
  updateChat: (id, payload) => axios.patch(`${API}/ai/chats/${id}`, payload, { headers: auth() }).then((r) => r.data),
  deleteChat: (id) => axios.delete(`${API}/ai/chats/${id}`, { headers: auth() }).then((r) => r.data),
  teams: () => axios.get(`${API}/teams`, { headers: auth() }).then((r) => r.data),
  contacts: () => axios.get(`${API}/messages/conversations`, { headers: auth() }).then((r) => r.data.conversations.filter((c) => c.kind === 'direct' && !c.is_bot)),
  task: (id) => axios.get(`${API}/tasks/${id}`, { headers: auth() }).then((r) => r.data),
  moveTask: (id, status) => axios.patch(`${API}/tasks/${id}`, { status }, { headers: auth() }).then((r) => r.data),
  reminders: () => axios.get(`${API}/reminders`, { headers: auth() }).then((r) => r.data.reminders),
  createReminder: (payload) => axios.post(`${API}/reminders`, payload, { headers: auth() }).then((r) => r.data),
  cancelReminder: (id) => axios.delete(`${API}/reminders/${id}`, { headers: auth() }).then((r) => r.data),
  snoozeReminder: (id, dueAt) => axios.post(`${API}/reminders/${id}/snooze`, { due_at: dueAt }, { headers: auth() }).then((r) => r.data),
};

// POST the message and read the Server-Sent Events reply token by token.
export async function streamChatMessage(chatId, { content, model, signal, onEvent }) {
  const res = await fetch(`${API}/ai/chats/${chatId}/messages`, {
    method: 'POST',
    headers: { ...auth(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ content, model }),
    signal,
  });
  if (!res.ok) {
    let detail = `Request failed (${res.status})`;
    try { detail = (await res.json()).detail || detail; } catch { /* non-JSON error body */ }
    throw new Error(detail);
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    let idx;
    while ((idx = buffer.indexOf('\n\n')) >= 0) {
      const chunk = buffer.slice(0, idx);
      buffer = buffer.slice(idx + 2);
      chunk.split('\n').forEach((line) => {
        if (line.startsWith('data:')) onEvent(JSON.parse(line.slice(5).trim()));
      });
    }
  }
}
